import { render, staticRenderFns } from "./SidebarSpacer.vue?vue&type=template&id=74b8e983&scoped=true"
import script from "./SidebarSpacer.vue?vue&type=script&lang=js"
export * from "./SidebarSpacer.vue?vue&type=script&lang=js"
import style0 from "./SidebarSpacer.vue?vue&type=style&index=0&id=74b8e983&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b8e983",
  null
  
)

export default component.exports